import { render } from "./HomeHero.vue?vue&type=template&id=4aa53335&scoped=true"
import script from "./HomeHero.vue?vue&type=script&lang=js"
export * from "./HomeHero.vue?vue&type=script&lang=js"

import "./HomeHero.vue?vue&type=style&index=0&id=4aa53335&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa53335"]])

export default __exports__